export const getErrorObj = (error: unknown): { [key: string]: string } => {
  return {
    error:
      error instanceof Error
        ? JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)))
        : {},
  };
};
